/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: navbar-component.js
 *
 * Created by rsorensen-lb on 5/18/17.
 */

function NavbarController(
    this: JS5Object,
    _: JS5Object,
    $location: JS5Object,
    $route: JS5Object,
    $routeParams: JS5Object,
    $uibModal: JS5Object,
    jwtStore: JS5Object,
    loginService: JS5Object,
    BreadcrumbService: JS5Object,
    UsersService: JS5Object,
    NavbarUtilService: JS5Object,
    PaginationService: JS5Object,
    PermissionsService: JS5Object,
    SearchFilterService: JS5Object,
    SidebarService: JS5Object
) {
    this.$onInit = () => {
        this.username = () => {
            return jwtStore.decode().sub;
        };
        PermissionsService.isExternalUser()
            .then((isExternalUser: boolean) => {
                this.canChangePassword = !isExternalUser;
            })

        this.showPMViewMenu = $location.path() === '/packages';

        if (this.searchEnabled === undefined) {
            this.searchEnabled = $route.current.searchEnabled ||
                $location.path() === '/packages/package/edit/' + $routeParams.id + '/collaborators';
        }

        if (this.filterEnabled === undefined) {
            this.filterEnabled = $route.current.filterEnabled;
        }

        if (this.showRefreshOnly === undefined) {
            this.showRefreshOnly = $route.current.showRefreshOnly;
        }

        NavbarUtilService.clearCurrentSearch = this.onClearCurrentSearch;
    };

    var doLogout = () => {
        var deferred = loginService.logout();

        deferred.then(() => {
                SidebarService.clearSessionData();
                PermissionsService.clearPermissions();
                PaginationService.resetToDefaultValues();
                $location.path('/login');
                $location.search({});
                BreadcrumbService.clearBreadcrumbs();
            },
            () => {
                this.errors = 'Failed to logout user.';
            });

        return deferred;
    };

    this.logout = () => {
        if (BreadcrumbService.editService && BreadcrumbService.editService.postCloseUpdate) {
            BreadcrumbService.editService.postCloseUpdate().then(() => {
                return doLogout();
            });
        } else {
            return doLogout();
        }
    };

    this.newPassword = '';

    this.keywords = (newKeywords?: string) => {
        let criteria = SearchFilterService.getCurrentSearchCriteria();
        if (newKeywords !== undefined) {
            criteria.keywords = newKeywords;
        } else {
            return criteria.keywords;
        }
    };

    // Bound to searchField in template

    this.openChangePasswordModal = () => {
        UsersService.openChangePasswordModal();
    };

    this.setPMView = (newView: string) => {
        if ($location.path() === '/packages') {
            $location.search('pmView', newView);
        } else {
            $location.search('pmView', null);
        }
    };

    this.getPMViewSelectorLabel = () => {
        if (this.showPMViewMenu) {
            switch ($location.search().pmView) {
                case 'basic' :
                    return 'Basic Inventory View';
                case 'detailed' :
                    return 'Detailed View';
                case 'status' :
                    return 'Status View';
                default :
                    this.setPMView('basic');
                    return 'Basic Inventory View';
            }
        }

        return '';
    };

    this.setSearchText = (forceUpdate: boolean) => {
        PaginationService.currentPage = 1;
        var previousText = $location.search().searchText;
        var currentText = this.keywords();
        if (currentText && currentText.length > 0) {
            $location.search('searchText', currentText);
        } else {
            $location.search('searchText', null);
        }

        if (NavbarUtilService.viewSearchFunction) {
            var refresh = forceUpdate && (!previousText || previousText === currentText);
            NavbarUtilService.viewSearchFunction(currentText, refresh);
        }
    };

    this.refreshView = () => {
        if (NavbarUtilService.viewSearchFunction) {
            NavbarUtilService.viewSearchFunction();
        }
    };

    this.filterBtnClickHandler = () => {
        if (NavbarUtilService.viewFilterBtnHandler) {
            NavbarUtilService.viewFilterBtnHandler();
        }
    };

    this.reportBtnHandler = (reportType: string) => {
        if (NavbarUtilService.viewReportButtonHandlers[reportType]) {
            NavbarUtilService.viewReportButtonHandlers[reportType]();
        }
    };

    this.isFilterApplied = SearchFilterService.isSearchFilterApplied;

    this.findNext = () => {
        NavbarUtilService.searchButtonHandlers.onFindNext();
    };

    this.findPrevious = () => {
        NavbarUtilService.searchButtonHandlers.onFindPrevious();
    };

    this.getSearchResultCountString = (): string => {
        const currentIndex = NavbarUtilService.currentSearchResultIndex;
        const totalResults = NavbarUtilService.searchResultTotal;
        const searchText = $location.search().searchText;

        if (_.size(searchText) && NavbarUtilService.searchResultTotal > 0) {
            return `${currentIndex} of ${totalResults}`;
        } else {
            return '';
        }
    };

    this.getNoResultsMsg = (): string => {
        const searchText = $location.search().searchText;

        if (_.size(searchText) &&
            NavbarUtilService.searchResultTotal === 0 &&
            NavbarUtilService.showNoResultsMsg) {
            return `${searchText} not found.`
        } else {
            return '';
        }
    };

    this.onClearCurrentSearch = () => {
        //
        // TODO
        //
        // This should probably clear out all search criteria
        //

        this.keywords('');
        $location.search('searchText', null);
    };
}

angular
    .module('prism-ui.components.navigation')
    .component('navbar', {
        templateUrl: 'components/navigation/navbar/navbar-template.html',
        controller: NavbarController,
        bindings: {
            searchEnabled: '<',
            filterEnabled: '<',
            showNextPreviousButtons: '<',
            showRefreshOnly: '<'
        }
    });
